export default "__VITE_ASSET__xj5vkczF__"